import { Button, DialogActions, DialogContent } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TbBriefcase } from "react-icons/tb";

import CommonPopup from "@/components/CommonPopup";
import { useUsersLifecycleInfo, useUsersTableActions } from "@/stores/use-users-table";

import UserLifecycleHeader from "./UserLifecycleHeader";
import { UserLifecycleInfoTimelineItem } from "./UserLifecycleTimeLineItem";

function UserLifecycleDialog() {
    const userLifecycleInfo = useUsersLifecycleInfo();
    const { updateLifecycleInfo } = useUsersTableActions();
    const onClose = () => {
        updateLifecycleInfo();
    };
    return (
        <CommonPopup
            title={"Kullanıcı Çalışma Dönemleri"}
            icon={TbBriefcase}
            open={!!userLifecycleInfo}
            size="sm"
            onClose={onClose}
        >
            <UserLifecycleInfoContent />
        </CommonPopup>
    );
}

function UserLifecycleInfoContent() {
    const userLifecycleInfo = useUsersLifecycleInfo();
    const { updateLifecycleInfo } = useUsersTableActions();
    const handleClose = () => {
        updateLifecycleInfo();
    };
    const { t } = useTranslation();
    if (!userLifecycleInfo) return null;
    return (
        <>
            <DialogContent dividers>
                <UserLifecycleHeader />
                <div className="flex flex-col gap-3 ">
                    {userLifecycleInfo.lifecycles.map((item, index) => {
                        return <UserLifecycleInfoTimelineItem key={item.id} lifecycle={item} index={index} />;
                    })}
                </div>
            </DialogContent>
            <DialogActions>
                <Button autoFocus color="secondary" variant="outlined" onClick={handleClose}>
                    {t("buttons.close")}
                </Button>
            </DialogActions>
        </>
    );
}

export default UserLifecycleDialog;
